import React from 'react';
import { Say } from "../widgets/Say";

/** speak British RP with a consistent voice */
export function SayRP(props: { children: string }) {
  return <Say pitch={55} accent='English RP' textColor='rgb(141, 31, 38)'>{props.children}</Say>;
}
